import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { analyzeLevelDurationByAd, analyzeLevelDurationByAdCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "userSegmentationAcrossDifferentChannels",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [// {
      //   label: "新增设备",
      //   id: "device_id"
      // },
      {
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        ad_channel: this.searchData.ad_channel,
        ad_placement: this.searchData.ad_placement
      };
      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      console.log("searchCurrency===", searchCurrency);
      var reqFn = searchCurrency.length ? analyzeLevelDurationByAdCurrency : analyzeLevelDurationByAd;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var statusArr = []; //处理表头

          if (!data || !data[0]) {
            return;
          }

          for (var i in data[0]["levels"]) {
            statusArr.push(i);
          }

          statusArr.forEach(function (item) {
            _this2.tableList.push({
              label: _this2.$t('levelPassCount', {
                level: item
              }),
              prop: "".concat(item, "_pass_count")
            }, {
              label: _this2.$t('levelAvgDuration', {
                level: item
              }),
              prop: "".concat(item, "_avg_duration")
            });
          });
          var tableCopyData = JSON.parse(JSON.stringify(data));
          tableCopyData.forEach(function (item) {
            for (var j in item.levels) {
              item["".concat(j, "_pass_count")] = item.levels[j]["pass_count"];
              item["".concat(j, "_avg_duration")] = item.levels[j]["avg_duration"];
            }
          });
          _this2.tableData = tableCopyData;

          _this2.tableList.unshift({
            label: _this2.$t('productLabel'),
            prop: 'product_name'
          }, {
            label: _this2.$t('adChannel'),
            prop: 'ad_channel'
          }, {
            label: _this2.$t('adPlacement'),
            prop: 'ad_placement'
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};